module.exports = __webpack_public_path__ + "img/testCenter.c6a1cd5c.png";